export default "__VITE_ASSET__10358a92__"